import Axios from "axios";
import React, { useState } from "react";
import { BiCheck, BiCheckbox, BiCheckSquare } from "react-icons/bi";
import { BsCheckSquare, BsCheckSquareFill } from "react-icons/bs";
import { IoIosCheckmark } from "react-icons/io";
import {
  useLocation,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";

const FraudVerificationPage = () => {
  const location = useLocation();
  const history = useHistory();

  const { m_payment_id, reponseMessage, customer_id } = location.state || {};
  const [otp, setOTP] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [subBtn, setSubBtn] = useState("save-btn");
  const [status, setStatus] = useState("");

  const baseURL = "https://karamale.com/apps/kscanner/webservices.php";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (otp.trim() === "") {
      setMessage("Enter OTP");
      setMessageAlert("error-login");
      return;
    }

    if (email.trim() === "") {
      setMessage("Enter your exisitng email address");
      setMessageAlert("error-login");
      return;
    }
    const formData = new FormData();
    formData.append("m_payment_id", m_payment_id);
    formData.append("customer_id", customer_id);
    formData.append("otp", otp);
    formData.append("email", email);
    formData.append("query", "VERIFY-CUSTOMER-TRANSACTION");

    setLoading(true);
    setSubBtn("btn-disabled text-bold");

    try {
      Axios({
        url: baseURL,
        method: "POST",
        data: formData,
        withCredentials: true,
      })
        .then((response) => {
          setSubBtn("save-btn");
          setLoading(false);
          const result = response.data;
          console.log(result.status);
          if (result.status === "success") {
            setStatus(result.status);
            setMessage(result.message);
            setMessageAlert("success-login");
          } else {
            setMessage(result.message);
            setMessageAlert("error-login");
          }

          setTimeout(() => {
            setMessage("");
          }, 5000);
        })
        .catch((err) => {
          setMessage(err);
          setMessageAlert("error-login");
        });
    } catch (err) {
      console.error(err);
      setMessage("An error occurred while uploading the ID.");
      setMessageAlert("error-login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div className={status !== "success" ? "d-none" : "text-center"}>
          <h5>
            <BsCheckSquareFill size={20} color={"green"} /> Identity Verified
          </h5>
          <label
            className="cancel-btn w-100 mt-2"
            onClick={() => history.goBack()}
          >
            Start New Purchase
          </label>
        </div>
        <div className={status === "success" ? "d-none" : ""}>
          <label className="alert alert-warning p-2">{reponseMessage}</label>

          <h5 style={styles.title}>Verify Your Identity</h5>
          <p style={styles.text}>
            We've sent a verification code to your email. Please enter it below
            to continue.
          </p>
          <form onSubmit={handleSubmit} style={styles.form}>
            <label htmlFor="id_upload" className="mb-0">
              Enter your valid OTP
            </label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOTP(e.target.value)}
            />

            <label htmlFor="id_upload" className="mb-0">
              Enter your existing email address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              type="submit"
              disabled={loading ? true : false}
              className={subBtn}
            >
              {loading ? "Verifying..." : "Submit Verification"}
            </button>
          </form>
        </div>

        {message && <div className={messageAlert}>{message}</div>}
      </div>
    </div>
  );
};

// Inline styles
const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f0f2f5",
    padding: "20px",
  },
  card: {
    backgroundColor: "#fff",
    padding: "15px 15px",
    borderRadius: "12px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "450px",
  },
  title: {
    marginBottom: "15px",
    textAlign: "left",
    color: "#333",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "20px",
    textAlign: "left",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  button: {
    padding: "12px",
    borderRadius: "6px",
    border: "none",
    backgroundColor: "#4a90e2",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  message: {
    marginTop: "15px",
    color: "green",
    textAlign: "left",
  },
};

export default FraudVerificationPage;
